'use strict';

var _utils = require('./utils');

require('angular');

require('jquery');

require('bootstrap');

require('moment');

require('bootstrap/dist/css/bootstrap.css');

require('bootstrap/dist/css/bootstrap-theme.css');

require('angularjs-slider/dist/rzslider.min.css');

require('./styles/default.sass');

require('./styles/safari.css');

require('angularjs-slider');

require('../modules/angular-custom-daterangepicker');

require('font-awesome-webpack!./font-awesome.config.js');

require('@uirouter/angularjs');

require('angular-google-analytics');

require('./locales');

require('./index');

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

require('angular-select2');

require('select2/select2.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _utils.getLog)('[Boot]');

log('Running.');

var wrc = window.winresCloud;

// Set publicPath dynamically
if (WEBCOMPONENTS_ASSETS) {
    // Hard-coded at build time
    // log('Asset path was set at compile-time.');
    __webpack_public_path__ = WEBCOMPONENTS_ASSETS;
} else if (wrc && wrc.assets) {
    // log('Asset path was set at run-time.');
    __webpack_public_path__ = wrc.assets;
} else {
    throw new Error('[WebComponents boot] Asset path not set. ' + 'It must be set either at run-time through winresCloud.assets ' + 'or at compile-time using the --baseurl parameter.');
}
// log('Asset path:', __webpack_public_path__);

// First include to use ES6 functionality in older browsers
//import 'core-js';

// Include Bootstrap (UI only, Bootstrap JS is not required.)
require('angular-ui-bootstrap');
require('angular-scroll');

require('jquery');

require('angular-messages');
require('angular-sanitize');

// No M-Files split here, directly include the Winres environment.
require('../environment/winres/boot.js');

// Finally load our global styles. Note that webpack passess all CSS through
// steps that wrap them in .winres-web-component { ... }, so that these do not
// interfere with site.
// NOTE: These (as with all CSS that is imported) are compiled into webcomponents.css.


// Daterangepicker
//import 'bootstrap-daterangepicker';
//import 'angular-daterangepicker';

require('!style!css!bootstrap-daterangepicker/daterangepicker.css');

// More Glyphicons


// Note that these are loaded with file-loader, thus these are NOT included in
// the bundle and will be loaded dynamically. Adding locales here does not slow
// the app down.
require('angular-i18n/angular-locale_fi.js');
require('angular-i18n/angular-locale_en.js');
require('angular-i18n/angular-locale_sv.js');
require('angular-i18n/angular-locale_de.js');
require('angular-i18n/angular-locale_ru.js');

require('i18next-xhr-backend');
window.i18n = require('i18next-client');
require('ng-i18next');

// Google analytics
// https://github.com/revolunet/angular-google-analytics

require('../core');
require('../reservation');
require('../winresCloud');

require('select2');

// Google analytics provider.
_module3.default.config(['AnalyticsProvider', function (AnalyticsProvider) {
    AnalyticsProvider.setAccount('UA-XXXXXXX-X') // Default tracking id.
    .delayScriptTag(true).ignoreFirstPageLoad(true).trackPages(true).trackUrlParams(true).setPageEvent('$stateChangeSuccess').logAllCalls(false).setDomainName('none')
    //.enterDebugMode(false)
    .useECommerce(true, true).setCurrency('EUR');
}]).run(['Analytics', function (Analytics) {}]);

function updateAnalyticsAccount(Analytics, gaCode) {
    if (!gaCode) return;

    var trackerId = gaCode;
    Analytics.configuration.accounts[0].tracker = trackerId;
    //Analytics.createAnalyticsScriptTag();
    Analytics.registerScriptTags();
    Analytics.registerTrackers();
    Analytics.pageView();

    log('Update Google analytics:', gaCode);
}

function createDataLayer(dtCode) {
    window.dataLayer = window.dataLayer || [];

    if (window.dataLayer.length === 0) {
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != 'dataLayer' ? '&l=' + l : '';j.async = true;j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', dtCode);

        log('Create dataLayer:', dtCode, window.dataLayer);
    } else {
        log.error('Failed to create dataLayer (already exists):', window.dataLayer);
    }
}

function handleAnalyticsAndDataLayer(user, Analytics) {
    var gaCodeParam = _.find(user.loginResult.ParameterList, function (p) {
        return p.Code === 'GoogleAnalyticsCode';
    });
    if (gaCodeParam && gaCodeParam.Value) {
        var gaCode = gaCodeParam.Value;
        updateAnalyticsAccount(Analytics, gaCode);
    } else {
        log.warn('Google Analytics: gaCode is null.');
    }

    var gtmCodeParam = _.find(user.loginResult.ParameterList, function (p) {
        return p.Code === 'GoogleTagManagerCode';
    });
    if (gtmCodeParam && gtmCodeParam.Value) {
        var gtmCode = gtmCodeParam.Value;
        createDataLayer(gtmCode);
    } else {
        log.warn('DataLayer: gtmCode is null');
    }
}

// Disable debug info for performance reasons.
_module3.default.config(['$compileProvider', function ($compileProvider) {
    //$compileProvider.debugInfoEnabled(true);
    $compileProvider.debugInfoEnabled(false);
    $compileProvider.commentDirectivesEnabled(false);
    //$compileProvider.cssClassDirectivesEnabled(false);
    $compileProvider.preAssignBindingsEnabled(true);
}]);

var sessionPrefix = wrc && wrc.sessionPrefix || null;
_module3.default.constant('sessionPrefix', sessionPrefix);

// Disable ALL URL MANIPULATION MADE BY ANGULAR
if (wrc && wrc.noUrlManipulation) {
    _module3.default.config(['$provide', function ($provide) {
        $provide.decorator('$browser', ['$delegate', function ($delegate) {
            $delegate.onUrlChange = function () {};
            $delegate.url = function () {
                return "";
            };
            return $delegate;
        }]);
    }]);
}

_module3.default.config(['$qProvider', function ($qProvider) {
    $qProvider.errorOnUnhandledRejections(true);
}]);

_module3.default.config(['styleServiceProvider', function (styleServiceProvider) {
    try {
        styleServiceProvider.setStyle(wrc ? wrc.style : null);
        styleServiceProvider.setContext(require.context('./styles/custom', false, /\/[^_][^\/]*\.sass$/));
    } catch (e) {
        log.error("styleServiceProvider error:", e);
    }
}]);

_module3.default.config(['localizationServiceProvider', function (localizationServiceProvider) {
    localizationServiceProvider.setDefaultLanguage('fi');
    if (wrc && wrc.locale) {
        localizationServiceProvider.addCustomNamespace(wrc.locale);
    }
}]);

_module3.default.config(['$stateProvider', function ($stateProvider) {
    var resolve = {
        search: ['urlService', '$transition$', function (urlService, t) {
            urlService.setRouteParams(t.params());
        }]
    };

    $stateProvider.state('query-params', {
        //url : '/?:d&:dn&:dc&:pc&:bd&:ed&:na&:nc&:ni&:dp',
        url: '/?:type&:region&:startDate&:endDate&:numAdults&:numChildren&:numInfants&:dc1&:dc2&:dc3&:dc4&:dc5&:dp',
        resolve: resolve
    });
}]);

_module3.default.config(['$locationProvider', function ($locationProvider) {
    // Prevent Angular default behavior that adds #! before anchor links (#test -> #!#test)
    if (wrc.useQueryString) {
        $locationProvider.html5Mode({ enabled: true, requireBase: false });
    } else {
        $locationProvider.html5Mode(window.location.host !== 'omalomat.fi' && window.location.href.search('#') > 0 && window.location.href.search('#!') === -1);
    }
}]);

// Automatically login with the settings provided.
_module3.default.run(['userService', 'urlService', '$log', '$rootScope', 'styleService', 'Analytics', function (userService, urlService, $log, $rootScope, styleService, Analytics) {
    if (!wrc) {
        $log.error('window.winresCloud is not specified. ' + 'Please check the winresCloud tags.');
        return;
    }

    if (wrc.manualLogin) {
        $log.debug('Manual login mode enabled.');
    } else {
        // Define alternative names that sound less alarming
        // for the "username" and "password" fields.
        // In case of web components, they're just used to identify
        // the calling site to the server, not for authentication.
        var username = wrc.site || wrc.username;
        var password = wrc.identifier || wrc.password;

        if (!username || !password) {
            $log.error('window.winresCloud is is incomplete.' + 'Please check the winresCloud tags.');
            return;
        }

        var user = userService.getCurrentUser();
        if (!user || user.getUserName() != username) {
            userService.login(username, password);
        }

        $rootScope.$on('sessionExpired', function () {
            userService.login(username, password);
        });

        if (user) {
            handleAnalyticsAndDataLayer(user, Analytics);
        }
    }

    $rootScope.$on('login', function (e, user) {
        handleAnalyticsAndDataLayer(user, Analytics);
    });

    if (!wrc || !wrc.style) {
        $rootScope.$on('login', function (e, user) {
            // log('Logged in:', user);
            styleService.setStyle(user.getStyle());
        });

        var _user = userService.getCurrentUser();
        if (_user) {
            // log('Has current user, setting style:', user.getStyle());
            styleService.setStyle(_user.getStyle());
        }
    }

    urlService.checkUrl();

    String.prototype.replaceAll = function (target, replacement) {
        return this.split(target).join(replacement);
    };
}]);

var bootstrap = function bootstrap() {
    if (window.winresBooted) {
        log.warn('Already called bootstrap once. Not doing it again.');
        return;
    }
    window.winresBooted = true;
    angular.bootstrap(document, ['winresCloudWebComponents'], { strictDi: true });
    defineWrapper();
    addGmaps();
};

var body = document.getElementsByTagName('body');
if (body && body.length > 0) {
    // The normal case.
    bootstrap();
} else {
    // This can happen if webcomponents.js is loaded in the <head>.
    // Calling angular.bootstrap initializes localizationService, which calls
    // tmhDynamicLocale.set, which crashes if there is no body tag.
    log('There is no body tag yet. Waiting for the page to load.');
    window.addEventListener('load', function (event) {
        log('The page has now loaded.');
        bootstrap();
    });
}

function defineWrapper() {
    var prf = '[winres-wrapper-script]';

    try {
        var wrapperScript = document.getElementById('winres-wrapper-component-script');
        if (!wrapperScript) {
            console.debug(prf, 'Appending wrapper component script tag.');
            var script = document.createElement('script');
            script.id = 'winres-wrapper-component-script';
            script.src = 'https://sites2.matkaverkko.fi/levi/komponentit/wrapper.js';
            document.body.appendChild(script);
        } else {
            console.debug(prf, 'Wrapper component script tag already exists.');
        }
    } catch (e) {
        console.error(prf, 'Failed to append wrapper component script tag:', e);
    }
};

function addGmaps() {
    var prf = '[winres-wrapper-script]';

    try {
        var script = document.getElementById('winres-gmaps-script');
        if (!script) {
            console.debug(prf, 'Appending Google Maps script tag.');
            var initMapScript = document.createElement('script');
            initMapScript.text = "function winresInitMap() { var maps = document.getElementsByTagName('winres-reservation-map'); for(var i=0;i<maps.length;i++){ angular.element(maps[i]).controller('winresReservationMap').$onInit(); }}";
            document.body.appendChild(initMapScript);
            var _script = document.createElement('script');
            _script.id = 'winres-gmaps-script';
            _script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDFEEYCTiqz0NzptXlxbTi975-svcZBMWs&callback=winresInitMap';
            document.body.appendChild(_script);
        } else {
            console.debug(prf, 'Google Maps script tag already exists.');
        }
    } catch (e) {
        console.error(prf, 'Failed to append Google Maps script tag:', e);
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/boot.js
// module id = 0
// module chunks = 2